import { createAsyncThunk } from "@reduxjs/toolkit";

import * as financingAPI from "../../../api/financing";
import { config } from "../../../config";
import { getCaptchaToken } from "../../../forms/Captcha";
import {
    FinancingPreQualRequest,
    FinancingPreQualRequestResponse,
} from "../../../models/financing";

export const checkPreScreenStatus = createAsyncThunk(
    "financing/checkPreScreenStatus",
    async (
        reqData: FinancingPreQualRequest,
    ): Promise<FinancingPreQualRequestResponse> => {
        const recaptcha = config.get("ENABLE_CHECKOUT_CAPTCHA")
            ? await getCaptchaToken("financing_prequal")
            : null;
        const resp = await financingAPI.checkFinancingPreQualStatus(
            reqData,
            recaptcha,
        );
        return resp;
    },
);
